/**
 * Recursively removes all properties with undefined values from an object.
 *
 * @template T
 * @param {T} obj - The object to be sanitized.
 * @returns {$Shape<T>} - A new object with all undefined values removed.
 */
export const removeUndefinedDeep = <T>(
  obj: T,
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  seen: WeakSet<any> = new WeakSet(),
): Partial<T> => {
  // Return primitive values as is
  if (obj === undefined || obj === null || typeof obj !== 'object') return obj;

  // Prevent infinite recursion by detecting circular references
  // If object was already seen, return it without further processing
  if (seen.has(obj)) return obj;
  seen.add(obj);

  if (Array.isArray(obj)) {
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
    return obj.map(item => removeUndefinedDeep(item, seen));
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  const result: Record<string, any> = {};
  for (const key of Object.keys(obj)) {
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7053
    if (obj[key] !== undefined) {
      result[key] =
        // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7053
        obj[key] && typeof obj[key] === 'object'
          ? // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7053
            removeUndefinedDeep(obj[key], seen)
          : // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7053
            obj[key];
    }
  }
  // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
  return result;
};
